import { useCustom } from '@refinedev/core';
import type { PublicationTreeBatchOut } from '@/api/generated/schemas';

/**
 * Dependency trees: products, publisher, authors, lectors with their
 * `mod_status`. Looked up by product (format) ids when given — the tree
 * then carries exactly those formats and their publications — otherwise
 * by publication ids. The provider serialises arrays as repeated
 * `ids=1&ids=2`, which is the form FastAPI expects.
 */
export const usePublicationTrees = (
  ids: number[],
  productIds: number[] = [],
  enabled = true
) => {
  const byProduct = productIds.length > 0;
  const { query: result } = useCustom<PublicationTreeBatchOut>({
    url: 'user_catalog/publications/dependency_tree',
    method: 'get',
    config: { query: byProduct ? { product_ids: productIds } : { ids } },
    queryOptions: {
      enabled: enabled && (byProduct || ids.length > 0),
    },
  });
  return {
    trees: result.data?.data,
    isLoading: result.isLoading,
    isError: result.isError,
    refetch: result.refetch,
  };
};
